module.exports = __webpack_public_path__ + "static/media/heart.dd3b8096.png";